/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurableParameterDto } from './ConfigurableParameterDto';
import {
    ConfigurableParameterDtoFromJSON,
    ConfigurableParameterDtoFromJSONTyped,
    ConfigurableParameterDtoToJSON,
    ConfigurableParameterDtoToJSONTyped,
} from './ConfigurableParameterDto';

/**
 * A fee of the tunnel in the re-pricing model, with its value on the quote.
 * @export
 * @interface RetarificationFraisDto
 */
export interface RetarificationFraisDto {
    /**
     * Tunnel fee, null when the quote fee is not linked to a tunnel fee anymore (read only).
     * 
     * @type {string}
     * @memberof RetarificationFraisDto
     */
    remunerationTunnelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RetarificationFraisDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RetarificationFraisDto
     */
    valeurTunnel?: number | null;
    /**
     * Value set on the quote (amount or rate, as stored), null when the quote has no such fee.
     * @type {number}
     * @memberof RetarificationFraisDto
     */
    valeurDevis?: number | null;
    /**
     * Allowed values, null when the fee cannot be changed.
     * @type {ConfigurableParameterDto}
     * @memberof RetarificationFraisDto
     */
    parametres?: ConfigurableParameterDto | null;
    /**
     * Current annual amount incl. tax computed on the quote.
     * @type {number}
     * @memberof RetarificationFraisDto
     */
    montantTtcActuel?: number | null;
}

/**
 * Check if a given object implements the RetarificationFraisDto interface.
 */
export function instanceOfRetarificationFraisDto(value: object): value is RetarificationFraisDto {
    return true;
}

export function RetarificationFraisDtoFromJSON(json: any): RetarificationFraisDto {
    return RetarificationFraisDtoFromJSONTyped(json, false);
}

export function RetarificationFraisDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetarificationFraisDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remunerationTunnelId': json['remunerationTunnelId'] == null ? undefined : json['remunerationTunnelId'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'valeurTunnel': json['valeurTunnel'] == null ? undefined : json['valeurTunnel'],
        'valeurDevis': json['valeurDevis'] == null ? undefined : json['valeurDevis'],
        'parametres': json['parametres'] == null ? undefined : ConfigurableParameterDtoFromJSON(json['parametres']),
        'montantTtcActuel': json['montantTtcActuel'] == null ? undefined : json['montantTtcActuel'],
    };
}

export function RetarificationFraisDtoToJSON(json: any): RetarificationFraisDto {
    return RetarificationFraisDtoToJSONTyped(json, false);
}

export function RetarificationFraisDtoToJSONTyped(value?: RetarificationFraisDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remunerationTunnelId': value['remunerationTunnelId'],
        'libelle': value['libelle'],
        'valeurTunnel': value['valeurTunnel'],
        'valeurDevis': value['valeurDevis'],
        'parametres': ConfigurableParameterDtoToJSON(value['parametres']),
        'montantTtcActuel': value['montantTtcActuel'],
    };
}

